export default __webpack_public_path__ + "static/media/decaysofnature.040c1753.png";